import { ReactComponent as Teeth18 } from "assets/teeth/teeth18.svg";
import { ReactComponent as Teeth17 } from "assets/teeth/teeth17.svg";
import { ReactComponent as Teeth16 } from "assets/teeth/teeth16.svg";
import { ReactComponent as Teeth15 } from "assets/teeth/teeth15.svg";
import { ReactComponent as Teeth14 } from "assets/teeth/teeth14.svg";
import { ReactComponent as Teeth13 } from "assets/teeth/teeth13.svg";
import { ReactComponent as Teeth12 } from "assets/teeth/teeth12.svg";
import { ReactComponent as Teeth11 } from "assets/teeth/teeth11.svg";

import { ReactComponent as Teeth21 } from "assets/teeth/teeth21.svg";
import { ReactComponent as Teeth22 } from "assets/teeth/teeth22.svg";
import { ReactComponent as Teeth23 } from "assets/teeth/teeth23.svg";
import { ReactComponent as Teeth24 } from "assets/teeth/teeth24.svg";
import { ReactComponent as Teeth25 } from "assets/teeth/teeth25.svg";
import { ReactComponent as Teeth26 } from "assets/teeth/teeth26.svg";
import { ReactComponent as Teeth27 } from "assets/teeth/teeth27.svg";
import { ReactComponent as Teeth28 } from "assets/teeth/teeth28.svg";

import { ReactComponent as Teeth48 } from "assets/teeth/teeth48.svg";
import { ReactComponent as Teeth47 } from "assets/teeth/teeth47.svg";
import { ReactComponent as Teeth46 } from "assets/teeth/teeth46.svg";
import { ReactComponent as Teeth45 } from "assets/teeth/teeth45.svg";
import { ReactComponent as Teeth44 } from "assets/teeth/teeth44.svg";
import { ReactComponent as Teeth43 } from "assets/teeth/teeth43.svg";
import { ReactComponent as Teeth42 } from "assets/teeth/teeth42.svg";
import { ReactComponent as Teeth41 } from "assets/teeth/teeth41.svg";

import { ReactComponent as Teeth31 } from "assets/teeth/teeth31.svg";
import { ReactComponent as Teeth32 } from "assets/teeth/teeth32.svg";
import { ReactComponent as Teeth33 } from "assets/teeth/teeth33.svg";
import { ReactComponent as Teeth34 } from "assets/teeth/teeth34.svg";
import { ReactComponent as Teeth35 } from "assets/teeth/teeth35.svg";
import { ReactComponent as Teeth36 } from "assets/teeth/teeth36.svg";
import { ReactComponent as Teeth37 } from "assets/teeth/teeth37.svg";
import { ReactComponent as Teeth38 } from "assets/teeth/teeth38.svg";

export const teethCollection = {
  18: Teeth18,
  17: Teeth17,
  16: Teeth16,
  15: Teeth15,
  14: Teeth14,
  13: Teeth13,
  12: Teeth12,
  11: Teeth11,
  21: Teeth21,
  22: Teeth22,
  23: Teeth23,
  24: Teeth24,
  25: Teeth25,
  26: Teeth26,
  27: Teeth27,
  28: Teeth28,
  48: Teeth48,
  47: Teeth47,
  46: Teeth46,
  45: Teeth45,
  44: Teeth44,
  43: Teeth43,
  42: Teeth42,
  41: Teeth41,
  31: Teeth31,
  32: Teeth32,
  33: Teeth33,
  34: Teeth34,
  35: Teeth35,
  36: Teeth36,
  37: Teeth37,
  38: Teeth38,
};
